import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import '../style/style.css';
import '../style/bootstrap/yeti.css';
import App from './component/App.jsx';
ReactDOM.render(
  <App />,
  document.getElementById('container'));
